<template>
  <span class="c-radio-icon" :class="classes" :style/>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    active?: boolean;
    disabled?: boolean;
    size?: number;
  }>();

  const classes = computed(() => ({
    'c-radio-icon-active': props.active,
    'c-radio-icon-disabled': props.disabled,
  }));

  const style = computed(() => {
    if (!props.size) return {};
    const rems = (props.size ?? 16) / 16;
    return {
      width: rems + 'rem',
      height: rems + 'rem',
    };
  });
</script>

<style lang="scss">
  .c-radio-icon {
    --bg-color: #{$neutral-0};
    --fg-color: #{$primary};

    width: 1rem;
    height: 1rem;
    display: inline-block;
    aspect-ratio: 1;
    background: var(--bg-color);
    border-radius: 50%;
    border: .125rem solid var(--fg-color);

    &-active {
      background: var(--fg-color);
      box-shadow: inset 0 0 0 .15rem var(--bg-color);
    }

    &-disabled {
      --bg-color: #{$disabled-bg};
      --fg-color: #{$disabled-fg};
    }
  }
</style>
